import { Alert, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { t } from 'ttag';

import Loading from 'common/components/Loading';

import EventbriteLogoImage from '@assets/eventbrite.svg';
import ZoomLogoImage from '@assets/zoom.svg';
import AuthLayout from '@domains/Auth/Layout';

import { useIntegrationAuthentication } from './queries';

const INTEGRATION_LOGOS = {
  eventbrite: { src: EventbriteLogoImage, alt: 'Eventbrite', width: 200 },
  zoom: { src: ZoomLogoImage, alt: 'Zoom', width: 160 },
};

const IntegrationOAuth = () => {
  const { type, code, error } = useParams();
  const [showError, setShowError] = useState(false);
  const { mutate: authenticate } = useIntegrationAuthentication();

  useEffect(() => {
    const processOauth = () => {
      // Handle error parameter
      if (error) {
        setShowError(true);
        return;
      }

      // If no code, close the window without further action
      if (!code) {
        window.close();
        return;
      }

      authenticate(
        { integrationType: type, code },
        {
          onSuccess: () => {
            window.close();
          },
          onError: () => {
            setShowError(true);
          },
        },
      );
    };

    processOauth();
  }, [type, code, error, authenticate]);

  const integrationLogo = INTEGRATION_LOGOS[type];

  return (
    <AuthLayout>
      <Space direction="vertical" size="middle" align="center" style={{ width: '100%' }}>
        {integrationLogo && (
          <img
            src={integrationLogo.src}
            alt={integrationLogo.alt}
            style={{ width: integrationLogo.width }}
          />
        )}

        {showError && (
          <Alert
            type="error"
            showIcon
            message={t`Authentication failed, please close this window and try again.`}
          />
        )}

        {!showError && <Loading />}
      </Space>
    </AuthLayout>
  );
};

export default IntegrationOAuth;
